// SS Read More Script 
document.querySelectorAll('.show-more').forEach( (btn) => {
	btn.addEventListener('click', function () {
		let txtMore = 'Read More'
		txtLess = 'Read Less'
		moreContent = this.parentElement.querySelector('.show-more-content');
		this.classList.toggle('active');
		if (this.classList.contains('active')) {
			this.innerHTML = txtLess;
			moreContent.style.display = 'block';
		} else {
			this.innerHTML = txtMore;
			moreContent.style.display = 'none';
		}
	});
});